import { render } from "./Welcome.vue?vue&type=template&id=1840c08f&scoped=true&ts=true"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"

import "./Welcome.vue?vue&type=style&index=0&id=1840c08f&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1840c08f"]])

export default __exports__